export const genders = [
  {
    id: 0,
    value: 'male',
    label: 'Male'
  },
  {
    id: 1,
    value: 'female',
    label: 'Female'
  },
  {
    id: 2,
    value: 'other',
    label: 'Other'
  },
  {
    id: 3,
    value: 'non_binary',
    label: 'Non-Binary'
  },
  {
    id: 4,
    value: 'transgender',
    label: 'Transgender'
  },
  {
    id: 5,
    value: 'prefer_not_to_respond',
    label: 'Prefer not to respond'
  }
];

export const races = [
  {
    id: 0,
    value: 'American Indian or Alaska Native',
    label: 'American Indian or Alaska Native'
  },
  {
    id: 1,
    value: 'Asian',
    label: 'Asian'
  },
  {
    id: 2,
    value: 'Black or African American',
    label: 'Black or African American'
  },
  {
    id: 3,
    value: 'Hispanic or Latino',
    label: 'Hispanic or Latino'
  },
  {
    id: 4,
    value: 'Native Hawaiian or Other Pacific Islander',
    label: 'Native Hawaiian or Other Pacific Islander'
  },
  {
    id: 5,
    value: 'White',
    label: 'White'
  }
];

export const marital_status = [
  {
    id: 0,
    value: 'Married',
    label: 'Married'
  },
  {
    id: 1,
    value: 'Widowed',
    label: 'Widowed'
  },
  {
    id: 2,
    value: 'Separated',
    label: 'Separated'
  },
  {
    id: 3,
    value: 'Divorced',
    label: 'Divorced'
  },
  {
    id: 4,
    value: 'Single',
    label: 'Single'
  }
];

export const employmentType = [
  {
    value: 'Y',
    label: 'Employed'
  },
  {
    value: 'N',
    label: 'Unemployed'
  }
];

export const pronounOptions = [
  { value: 'he-him', label: 'He/Him' },
  { value: 'she-her', label: 'She/Her' },
  { value: 'they-them', label: 'They/Them' }
];

export const tax_id_types = [
  {
    value: 'E',
    label: 'EIN'
  },
  {
    value: 'S',
    label: 'SSN'
  }
];

export const practice_kinds = [
  {
    value: 'medical',
    label: 'Medical'
  },
  {
    value: 'dental',
    label: 'Dental'
  }
];

export const practice_status = [
  {
    value: 'pending',
    label: 'Pending'
  },
  {
    value: 'active',
    label: 'Active'
  },
  {
    value: 'inactive',
    label: 'Inactive'
  }
];
